import { AlertContext } from 'context'
import { useContext } from 'react'

const useAlert = () => useContext(AlertContext)

export { useAlert }
